import React from "react";
import { useTranslation } from "react-i18next";

function HowToDelete() {
    const { t } = useTranslation("howToDelete");

    return (
        <div className="card">
            <h1>{t("title")}</h1>

            <p>{t("intro")}</p>

            <p>
                <a href="mailto:appneuroplus@bnhancement.com">
                    appneuroplus@bnhancement.com
                </a>
            </p>

            <p>
                {t("subjectLabel")} <strong>{t("subjectValue")}</strong>
            </p>

            <p>{t("includeLabel")}</p>
            <ul>
                {t("includeItems", { returnObjects: true }).map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
            </ul>

            <p>{t("warning")}</p>
        </div>
    );
}

export default HowToDelete;